export default {
  boldPrice: {
    font: data => 'bold 18px ' + data.fontFamily1,
    padding: '0',
    color: '#333',
    display: 'block',
    '@media (min-width: 801px)': {
      fontSize: '24px',
      display: 'inline-block',
      verticalAlign: 'middle'
    }
  },
  stOfferPrice: {},
  monoHotelPriceHabi: {
    font: data => '400 16px ' + data.fontFamily1,
    marginLeft: '5px',
    display: 'inline',
    outline: 'none',
    color: data => data.defaultColor,
    '&$stOfferPrice':{color: data => data.STdefaultTier},    
    '@media (min-width: 801px)': {
      fontWeight: 'bold',
      fontSize: '20px'
    },
    '&:lang(ar)': {
      marginRight: '5px',
      marginLeft: 0,
      display: 'inline-block'
    }
  },
  monoHotelPrice: {
    font: data => '300 13px ' + data.fontFamily1,
    marginLeft: '5px',
    display: 'inline',
    color: data => data.defaultColor,
    '@media (min-width: 801px)': {
      fontWeight: 'bold',
      fontSize: '20px',
      marginLeft: '25px'
    },
    '&:lang(ar)': {
      marginRight: '5px',
      marginLeft: 0,
      '@media (min-width: 801px)': {
        marginRight: '25px',
        marginLeft: 0
      }
    }
  },
  monoHotelPrice2: {
    font: data => '300 13px ' + data.fontFamily1,
    marginLeft: '5px',
    display: 'inline',
    color: data => data.defaultColor,
    '@media (min-width: 801px)': {
      marginLeft: '0',
      fontWeight: 'bold',
      fontSize: '20px'
    },
    '&:lang(ar)': {
      marginRight: '5px',
      marginLeft: 0,
      '@media (min-width: 801px)': {
        marginRight: 0,
        marginLeft: 0
      }
    }
  },
  textMobile: {
    marginLeft: '15px',
    '&:lang(ar)': {
      marginRight: '15px',
      marginLeft: 0
    }
  },
  monoHotelOldPrice: {
    fontFamily: data => data.fontFamily1,
    fontSize: '11px',
    textDecoration: 'line-through',
    color: '#666',
    marginRight: '5px',
    display: 'inline',
    outline: 'none',
    '@media (min-width: 801px)': {
      fontSize: '13px',
      verticalAlign: 'bottom'
    },
    '@media (max-width: 901px)': {
      display: 'block',
      order: '2'
    },
    '&:lang(ar)': {
      marginRight: '0',
      marginLeft: '5px'
    }
  },
  oldPriceCalendar: {
    fontFamily: data => data.fontFamily1,
    fontSize: '11px',
    textDecoration: 'line-through',
    color: '#a8a8a8',
    marginRight: '5px',
    display: 'inline',
    '@media (min-width: 801px)': {
      fontSize: '16px',
      verticalAlign: 'bottom'
    },
    '&:lang(ar)': {
      marginRight: '0',
      marginLeft: '5px'
    }
  },
  summaryPriceLittle: {
    fontSize: '14px',
    fontWeight: '300',
    textDecoration: 'line-through',
    color: '#333',
    display: 'block',
    textAlign: 'right',
    '&:lang(ar)': {
      textAlign: 'left'
    }
  },
  bold: {
    fontWeight: 'bold'
  },
  hide: {
    display: 'none'
  },
  summaryPriceExtraSmall: {
    font: data => '400 11px ' + data.fontFamily1,
    color: '#9b9b9b'
  },
  summaryPriceSmall: {
    font: data => '700 13px ' + data.fontFamily1,
    color: data => data.defaultColor
  },
  summaryPriceSmallSoftGray: {
    font: data => '300 11px ' + data.fontFamily1,
    color: '#666666'
  },
  roboto13GrayBold: {
    font: "500 13px 'Roboto', sans-serif",
    color: '#666'
  },
  roboto11SoftGray300: {
    font: "300 11px 'Roboto', sans-serif",
    color: '#666666'
  },
  summaryPriceMedium: {
    font: data => '500 16px ' + data.fontFamily1,
    color: data => data.defaultColor
  },
  disaggregationPrice: {
    font: data => '300 13px ' + data.fontFamily1 + ' !important',
    color: data => data.defaultColor
  },
  summaryPriceBig: {
    font: data => 'bold 24px ' + data.fontFamily1,
    display: 'block',
    textAlign: 'right',
    outline: 'none',
    '&:lang(ar)': {
      textAlign: 'left'
    }
  },
  summaryPriceBigModule: {
    font: data => 'bold 18px ' + data.fontFamily1,
    display: 'block',
    textAlign: 'right',
    '&:lang(ar)': {
      textAlign: 'left'
    }
  },
  green: {
    color: data => data.secondColor
  },
  blue: {
    color: data => data.thirdColor
  },
  mainColor:{
    color: data => data.mainColor    
  },
  goldST:{
    color: '#847648'
  },
  promoCodeDiscount: {
    marginTop: '10px',
    color: data => data.secondColor,
    paddingLeft: '5px',
    '&:lang(ar)': {
      paddingLeft: 0,
      paddingRight: '5px'
    }
  }

};
